import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  IMappers,
  ISaveUserEstimationRequest,
  ISaveUserEstimationResponse,
} from '../../../repositories/price-estimator/v2/save-user-estimation';
import { TErrorApi } from '../../../types/error';

export const createMapper = (
  parameters: ISaveUserEstimationRequest,
): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => response,
  400: ({ message, errors }) =>
    new HttpBadStatusCodeError({
      statusCode: 400,
      message: message as string,
      domain: 'saveUserEstimation.ts',
      details: { errors: errors as TErrorApi, parameters: JSON.stringify(parameters) },
    }),
});

export type TMappedResponse200 = ISaveUserEstimationResponse;
export type TMappedResponse400 = HttpBadStatusCodeError;

export type TSaveUserEstimationMapped = TMappedResponse200 | TMappedResponse400;
